import React from 'react';

const Step2 = ({ formData, handleInputChange, setStep }) => {
  // ReactGA.event({
  //   category: 'Navigation',
  //   action: 'Page View',
  //   page_name: pageName
  // });

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'dentalCheck', value: answer === 'yes' } });
    if (answer === 'yes') {
      setStep(4); // ステップ3へ進む
    } else {
      setStep(5); // ステップ4へ進む
    }
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 2</h2>
      <p className="text-base mb-4 text-lg">
        歯医者さんで定期的に歯のチェックを受けていますか？<br /><br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(2)}
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step2; 